import { Spinner } from "@/components/spinner/spinner";
import { DashboardRoutes } from "@/constants/routes";
import { useAuth } from "@/context/auth/useAuth";
import { featuresService } from "@/services/featuresService";
import { Navigate, Outlet } from "react-router";

type FeatureRouteProps = {
  /** Feature exigida para acessar a rota (ex.: "read:chat"). */
  feature: string;
  /** Rota de redirecionamento quando o usuário não possui a feature. */
  redirectTo?: string;
};

/**
 * Guarda de rota baseada em feature. Bloqueia o acesso direto (via URL) a páginas
 * cuja feature o usuário não possui, espelhando a checagem feita na navegação.
 * Aguarda `featuresLoaded` antes de decidir para evitar redirecionamento prematuro.
 */
export const FeatureRoute = ({
  feature,
  redirectTo = DashboardRoutes.DASHBOARD,
}: FeatureRouteProps) => {
  const { featuresLoaded } = useAuth();

  if (!featuresLoaded) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!featuresService.hasFeature(feature)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};
